export const heroSlides = [
  {
    id: "hero-1",
    title: "星际边界",
    tagline: "跨越宇宙尽头，只为寻找那一束回家的光",
    image: "https://readdy.ai/api/search-image?query=epic%20deep%20space%20panorama%20with%20a%20colossal%20glowing%20blue%20planet%20and%20a%20tiny%20lone%20starship%2C%20vast%20deep%20navy%20nebula%20with%20warm%20orange%20energy%20streaks%2C%20cinematic%20wide%20dramatic%20composition%2C%20highly%20detailed%20digital%20matte%20painting&width=1920&height=1000&seq=hero-01-bg&orientation=landscape",
    targetId: "movie-1",
  },
  {
    id: "hero-2",
    title: "都市繁花",
    tagline: "三位女性，一场关于自我绽放的都市漫游",
    image: "https://readdy.ai/api/search-image?query=glamorous%20city%20skyline%20at%20night%20with%20deep%20blue%20glass%20towers%20and%20warm%20orange%20streets%2C%20elegant%20urban%20atmosphere%2C%20cinematic%20wide%20dramatic%20composition%2C%20highly%20detailed%20cityscape%20photography&width=1920&height=1000&seq=hero-02-bg&orientation=landscape",
    targetId: "tv-2",
  },
  {
    id: "hero-3",
    title: "风暴救援",
    tagline: "逆风而行，与时间争夺每一条生命",
    image: "https://readdy.ai/api/search-image?query=massive%20ocean%20storm%20with%20giant%20waves%20and%20a%20rescue%20ship%2C%20deep%20navy%20clouds%20with%20warm%20orange%20flares%2C%20cinematic%20wide%20intense%20dramatic%20composition%2C%20highly%20detailed%20digital%20art&width=1920&height=1000&seq=hero-03-bg&orientation=landscape",
    targetId: "movie-5",
  },
  {
    id: "hero-4",
    title: "无声证词",
    tagline: "当所有人都选择沉默，真相仍在等待被听见",
    image: "https://readdy.ai/api/search-image?query=moody%20empty%20courtroom%20with%20deep%20blue%20shadows%20and%20a%20dramatic%20warm%20orange%20shaft%20of%20light%2C%20cinematic%20wide%20suspenseful%20composition%2C%20highly%20detailed%20interior%20photography&width=1920&height=1000&seq=hero-04-bg&orientation=landscape",
    targetId: "movie-8",
  },
];